import React from 'react'

class LogoDevops extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#BE895D" d="M336.61 149.076c4.215-7.106-6.122-24.617-10.313-32.53-4.187-7.91-10.14-4.534-17.77-1.66-7.636 2.878-57.01 1.224-57.01 1.224-5.238-14.455-18.92-28-18.92-28-38.572-32.525-86.804-22.754-88.89-22.367-7.976-17.128-18.778-31.226-23.35-34.096-5.797-3.64-15.41 2.75-22.88 24.606C93.895 66.753 96 77.72 99.152 86.29c-4.638 2.784-9.52 5.857-14.617 9.237-19.416 12.863-25.677 45.135-27.997 71.222-10.66 4.46-24.296 9.82-31.797 11.4-13.53 2.83-23.78 15-16.58 23.72 6.448 7.792 18.635 22.54 40.236 27.34-3.26 18.96-5.972 44.42-2.084 60.45 7.297 30.1 16.477 56.93 30.42 90.085 26.814 63.77 176.565 122.4 185.28 95.39 4.906-15.224 35.02-75.176 48.83-115.486 20.22-59-16.87-109.62-16.87-109.62s-17.57-19.49-12.62-19.516c4.95-.026 34.504-16.543 37.333-18.814 2.828-2.27 6.567-11.89-2.07-8.13-8.633 3.76-27.593 2.382-22.36 1.05 1.288-.33 3.163-1.11 5.33-2.106l.608 1.9 1.666-2.97c.802-.383 1.62-.784 2.453-1.195l1.5 4.165 3.034-6.41c.6-.3 1.196-.59 1.785-.873l1.04 4.84 3.8-7.08c1.48-.632 2.714-1.08 3.56-1.24 4.435-.82 8.04-8.55 15.122-19.646 7.08-11.097-1.763-17.825 2.457-24.928"/>
                    <path fill="#FEFEFE" d="M203.863 158.887l-22.92-17.178-3.028 4.03 22.92 17.18"/>
                    <path fill="#FEFEFE" d="M201.5 142.374l-17.188 22.91-4.032-3.027 17.187-22.91"/>
                </g>
            </svg>

        );
    }
}

export default LogoDevops



// WEBPACK FOOTER //
// ../components/SVG/LogoDevops.jsx